module.exports = __webpack_public_path__ + "img/pingan.30e6491b.png";